<datex-grid #$gridComponent *ngIf="initialized && !$hasMissingRequiredInParams"  [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"



>
    <ng-container topToolbar>
  </ng-container>


  <ng-container gridColumnDef="header1">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.header1.displayControl.styles.style"
          [ngClass]="row.cells.header1.displayControl.styles.classes"
          [matTooltip]="row.cells.header1.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.header1.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="header2">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.header2.displayControl.styles.style"
          [ngClass]="row.cells.header2.displayControl.styles.classes"
          [matTooltip]="row.cells.header2.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.header2.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="header3">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.header3.displayControl.styles.style"
          [ngClass]="row.cells.header3.displayControl.styles.classes"
          [matTooltip]="row.cells.header3.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.header3.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="header4">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.header4.displayControl.styles.style"
          [ngClass]="row.cells.header4.displayControl.styles.classes"
          [matTooltip]="row.cells.header4.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.header4.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="header5">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.header5.displayControl.styles.style"
          [ngClass]="row.cells.header5.displayControl.styles.classes"
          [matTooltip]="row.cells.header5.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.header5.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>


</datex-grid>
<div *ngIf="$hasMissingRequiredInParams" class="missing-params">
  <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
</div>
